// Shared, user-facing text helpers for channels (Spanish copy).

// "1 seguidor" / "N seguidores" — used by the channel page header and the
// profile channel list so the singular/plural rule lives in one place.
export const formatFollowersCount = (count: number): string =>
  count === 1 ? '1 seguidor' : `${count} seguidores`;
